import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GreenPower2Component } from './green-power2.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MeterGroupModule } from 'primeng/metergroup';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
    declarations: [GreenPower2Component],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        ChartModule,
        DropdownModule,
        ButtonModule,
        InputSwitchModule,
        MeterGroupModule,
        TooltipModule,
        ConfirmDialogModule,
    ],
    exports: [
        GreenPower2Component
    ]
})
export class GreenPower2Module { }
